module.exports = __webpack_public_path__ + "1a4c8221.woff2";